<template>
  <div id="Catalog" class="container">
    <div class="catalog-header">
      <h1 id="headerTitle">
        Parts Catalog
      </h1>
    </div>
    <!-- All Categories Section -->
    <div class="all-categories-section">
      <h2>All Categories</h2>
      <b-row v-show="isMainCategoriesLoading" class="justify-content-center">
        <loading-spinner />
      </b-row>
      <b-row v-show="!isMainCategoriesLoading">
        <b-col v-for="(category) in mainCategories" :key="category.Title" cols="6" sm="4" md="3" lg="2">
          <catalog-card :title="category.Title" :category-image-id="category.Image" :category-id="category.Id" />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { CatalogService } from "@/services/CatalogService"
import { ErrorLogService } from "@/services/ErrorLogService"
import LoadingSpinner from "@/components/Elements/LoadingSpinner"
import CatalogCard from "@/components/Elements/CatalogCard"
import { themeHelper } from "@/components/mixins/themeHelper";
import { siteSectionsHelper } from "@/components/mixins/siteSectionsHelper"
import { brandAndRegionAuthHelper } from "@/components/mixins"


export default {
  components: {
    LoadingSpinner,
    CatalogCard
  },
  mixins: [themeHelper, siteSectionsHelper, brandAndRegionAuthHelper],
  data: function () {
    return {
      mainCategories: [],
      isMainCategoriesLoading: true,
    }
  },
  computed: {
    ...mapGetters(["user", "activeAccountId", "brandAuth", "regionAuth", "audienceIds"])
  },
  created() {
    this.GetMainCategories();
  },
  methods: {
    GetCategoryImage(imageId) {
      if (imageId !== null && imageId !== "0") {
        return CatalogService.GetMediaUrl(imageId);
      }
      return this.getImage("noCategoryImageFound");
    },
    GetOnlyAuthorizedCategories(categories) {
      var authorizedCategories = categories.filter(x =>
        this.IsBrandRegionAuthorized(x.BrandAuth, x.RegionAuth)
      );
      return authorizedCategories
    },
    GetCategoryTitle(title) {
      if (title === "Tires and Load Wheels") {
        return "Tires";
      }
      else if (title === "Remanufactured Components") {
        return "Reman";
      }
      else {
        return title;
      }
    },
    GetMainCategories() {
      this.isMainCategoriesLoading = true;
      var costCenterRootCategoryId = this.$store.state.tenant.costCenterRootCategoryId;
      CatalogService.GetChildCategories(this.activeAccountId, this.user.UserId, costCenterRootCategoryId, this.brandAuth, this.regionAuth, this.audienceIds).then(cats => {
        this.mainCategories = cats.data.filter(x =>
          this.IsBrandRegionAuthorized(x.BrandAuth, x.RegionAuth)
        );
      }).catch(err => {
        ErrorLogService.LogException(err);
      }).then(() => {
        this.isMainCategoriesLoading = false
      })
    }
  }
}
</script>

<style lang="scss">
.catalog-header {
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;

  @media (min-width: $screen-sm-min) {
    flex-direction: row;
  }
}

.feature.catalog .col {
  margin-left: 0;
  width: 16.575%;
  border-left: 1px solid #c0c0c0;
}

.feature.catalog h1 {
  margin-bottom: 20px;
}

.feature.catalog img {
  display: block;
  margin: auto;
}

.feature.catalog h3 {
  background-color: #e4ebf6;
  padding: 3px 8px;
  line-height: 27px;
  font-size: 18px;
}

.feature.catalog ul {
  margin-left: 0;
  list-style-type: none;
  padding: 5px 8px;
}

.feature.catalog li {
  padding-bottom: 5px;
}

.all-categories-section {
  margin-top: 24px;
  border: 1px solid #c0c0c0;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);

  .row {
    padding: 12px;
  }

  h2 {
    background-color: $blue;
    color: #fff;
    padding: 3px 0 3px 15px;
    border-radius: 5px 5px 0 0;
  }
}
</style>